module.exports = __webpack_public_path__ + "img/insurance.da0e44b6.svg";